import React from 'react'
import StyledFlexContainer from './../../../../../components/containers/flex-container.component'
import {
	TextInput,
	SelectInput,
	TextAreaInput
} from '../../../../../components/form-components/inputs.component'

const firstContainerStyle = { marginBottom: '3.5rem' }

const ProductData = props => {
	return (
		<React.Fragment>
			<StyledFlexContainer marginTop={1} style={firstContainerStyle}>
				<TextInput
					className={'col-6'}
					autoFocus={true}
					label={'Nome *'}
					id={'name'}
					{...props}
				/>
				<TextInput
					onlyNumbers
					type={'tel'}
					maxLength={7}
					id={'quantity'}
					className={'col-2'}
					label={'Quantidade *'}
					{...props}
				/>
				<SelectInput
					options={statusOptions}
					className={'col-2'}
					label={'Situação'}
					multi={false}
					id={'active'}
					disabled
					{...props}
				/>
				<TextInput
					onlyNumbers
					type={'tel'}
					maxLength={7}
					id={'spotlightOrder'}
					className={'col-2'}
					label={'Ordem *'}
					{...props}
				/>
			</StyledFlexContainer>
			<TextAreaInput
				label={'Descrição *'}
				className={'col-12'}
				id={'description'}
				rows={'10'}
				{...props}
			/>
			<div style={fillerStyle} />
		</React.Fragment>
	)
}

const fillerStyle = {
	height: '10px',
	width: '10px'
}

const statusOptions = [
	{ value: 1, label: 'Ativo' },
	{ value: 0, label: 'Inativo' }
]

export default ProductData
